import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../common/Routes";
import { inProgress, isNullOrUndefined } from "../../../common/utils";
import { errorMsg } from "../../../components/simpleMessageAlert";
import { useGetUserGroupTypeId } from "./GetUserGroupTypeId";

export function UserGroupTypeNotFound(uniqueName) {
  return `User group type ${uniqueName} not found`;
}

export function useVerifyUserGroupType(userGroupTypeUniqueName) {
  const history = useHistory();

  const userGroupTypeApiProgress = useSelector((rootState) => {
    return rootState.userGroup.types.progress;
  });
  const userGroupTypeApiError = useSelector((rootState) => {
    return rootState.userGroup.types.error;
  });

  const [error, setError] = useState(null);

  const userGroupTypeId = useGetUserGroupTypeId(userGroupTypeUniqueName);

  useEffect(() => {
    if (!isNullOrUndefined(error)) {
      history.push(`${Routes.NotFound.path}`);
      errorMsg(error);
    }
  }, [error]);

  useEffect(() => {
    if (isUserGroupTypeApiLoadedWithNoIssues() && isNullOrUndefined(userGroupTypeId)) {
      setError(UserGroupTypeNotFound(userGroupTypeUniqueName));
    }

    function isUserGroupTypeApiLoadedWithNoIssues() {
      return !inProgress(userGroupTypeApiProgress) && isNullOrUndefined(userGroupTypeApiError);
    }
  });
}
